import type { RootState } from "../store"

export const coverageOverridesSelector = (state: RootState) =>
    state.coverageOverrides
